// Compiled at 2026-09-18T12:45:23.821Z
// Compiled at 2026-09-18T12:45:23.821Z
// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { Sys } from "@lg/ng-shared";
import * as Orders from "./Orders/Orders.js";
import * as System from "./System/System.js";
import * as Common from "./Common/Common.js";

export { Orders, System, Common };
Object.assign(globalThis, { Sys, Orders, System, Common, This: Orders })
